import { EProvince, getEProvinceList } from '@if/core/types'
import * as yup from '@if/core/yup'

const baseAddressCivicNumber = yup.string().nullable().default('')
const baseAddressStreet = yup.string().nullable().default('')
const baseAddressCity = yup.string().nullable().default('')
const baseAddressPostalCode = yup.string().nullable().default('').validCanadianPostalCode()
const baseAddressStateIso = yup
  .mixed<EProvince>()
  .nullable()
  .transform((value: string | null) => {
    return value === '' ? null : value
  })
  .default(null)
  .oneOf(getEProvinceList())
const baseAddressCountry = yup.string().nullable().default('Canada')

const fullAddressCivicNumber = baseAddressCivicNumber.required()
const fullAddressStreet = baseAddressStreet.required()
const fullAddressCity = baseAddressCity.required()
const fullAddressPostalCode = baseAddressPostalCode.required()
const fullAddressStateIso = baseAddressStateIso.required()
const fullAddressCountry = baseAddressCountry.required()

export const BaseAddressSchema = yup.object({
  civicNumber: baseAddressCivicNumber,
  street: baseAddressStreet,
  apartment: yup.string().nullable(),
  suite: yup.string().nullable(),
  city: baseAddressCity,
  postalCode: baseAddressPostalCode,
  country: baseAddressCountry,
  stateIso: baseAddressStateIso,
  note: yup.string().nullable().default(''),
  years: yup.number().nullable().min(0).default(0),
  months: yup.number().nullable().min(0).default(0),
})

export type BaseAddress = yup.InferSubmit<typeof BaseAddressSchema>

export const AddressSchema = BaseAddressSchema.when(([value]: BaseAddress[], schema: typeof BaseAddressSchema) => {
  if (value?.civicNumber || value?.apartment || value?.suite || value?.street || value?.city || value?.postalCode) {
    return schema.shape({
      civicNumber: fullAddressCivicNumber,
      street: fullAddressStreet,
      city: fullAddressCity,
      postalCode: fullAddressPostalCode,
      stateIso: fullAddressStateIso,
    })
  }
  return schema
})

export type Address = yup.InferSubmit<typeof AddressSchema>

export const FullAddressSchema = BaseAddressSchema.shape({
  civicNumber: fullAddressCivicNumber,
  street: fullAddressStreet,
  city: fullAddressCity,
  postalCode: fullAddressPostalCode,
  stateIso: fullAddressStateIso,
  country: fullAddressCountry,
})

export type FullAddress = yup.InferSubmit<typeof FullAddressSchema>
